
import $ from "jquery"

import StickyNavbarHandler from "app/sticky_navbar_handler"
import DataRetriever from "app/data_retriever"

import PicturesAndMap from "concepts/new_development_buildings/pictures_and_map_browser/tabbed"
import Buildings_Brochure_Request_Modal from "concepts/buildings/brochure/request/modal/index"
import ContactRequestBox from "concepts/new_development_buildings/contact/request/box/index"
import FloorPlan from "concepts/new_development_buildings/floor_plan/index"
import ListingsShareBar from "concepts/listings/share/bar/index"

const init = () => {
  const building_id = DataRetriever.get("building-id")

  $(".page-section--action-shortcuts__btn-contact")
  .on("click", (() => {
    const $active_contact_request_box =
      $(".cell-overseas-real-estate-projects-contact-request-box__new-development-contact-info__selectors")

    StickyNavbarHandler.scrollTo($active_contact_request_box)
  }))

  $(".page-section--overseas-real-estate-projects-description-block__content-brochure-request-button")
  .on("click", ((e) => {
    e.preventDefault()

    Buildings_Brochure_Request_Modal.show(building_id)
  }))

  ContactRequestBox.init()
  PicturesAndMap.init()
  FloorPlan.init()
  ListingsShareBar.create()
}

export default {
  init,
}
